import React from "react";
import logo from "./images/gif-720.gif";
import "./index.css";

const Home = () => {
  return (
    <section id="header" className="d-flex align-items-center">
      <div className="container-fluid" id="home">
        <div className="row align-items-center">
          <div className="col-10 mx-auto">
            <div className="row align-items-center">
              <div className="col-lg-7 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column">
                <h1>
                  Your body can stand almost anything.{" "}
                  <span>It's your mind</span> that you have to convince.
                </h1>
                <p className="subtitle d-none d-lg-block" style={{
                  fontSize: '1.125rem',
                  color: '#525252',
                  maxWidth: '500px',
                  marginBottom: '1.5rem',
                  lineHeight: '1.7'
                }}>
                  Professional health and safety consultancy for businesses of all sizes. 
                  Creating safer workplaces, one business at a time.
                </p>
                <div className="mt-3">
                  <a href="#footer" className="btn-get-started">
                    Get in Touch Now
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="col-lg-5 order-1 order-lg-2 header-img d-flex justify-content-center">
                <img 
                  src={logo} 
                  className="img-fluid animated" 
                  alt="Be Safe Keep Safe" 
                  style={{
                    maxWidth: '400px',
                    width: '100%',
                    height: 'auto',
                    borderRadius: '1.5rem'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
